import type { SaleTypeForPlan } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

type Props = {
	saleTypeForPlan: ForNodeType<SaleTypeForPlan>;
	onSetSaleTypeForPlan: (input: string) => void;
	saleTypeForPlanOptions: FormOptionType[];

	title?: string;
	guide?: string;
};

export const QuestionSaleTypeForPlan = ({
	saleTypeForPlan,
	onSetSaleTypeForPlan,
	saleTypeForPlanOptions,

	title: _title,
	guide: _guide,
}: Props) => {
	const title = _title ?? "プラン限定販売";
	const guide =
		_guide ??
		"紐付けたプランだけで販売可能な部屋に設定することができます。プランの選択なしでも予約可能な部屋の場合は”常に販売”を選びましょう。ホテルポリシーでプランの選択を必須にしている場合は、この選択は不要です。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={saleTypeForPlan.isEdited}
			hasError={Boolean(saleTypeForPlan.error)}
			guide={guide}
			inputChildren={
				<RadioGroupField
					value={saleTypeForPlan.value}
					handleValueChange={onSetSaleTypeForPlan}
					errorMessage={saleTypeForPlan.error}
					options={saleTypeForPlanOptions}
				/>
			}
		/>
	);
};

QuestionSaleTypeForPlan.displayName = "QuestionSaleTypeForPlan";
